<template>
  <div class="thaw-amount-list-wrap">
    <div class="table-wrapper">
      <el-table :data="tableData" stripe v-loading="loading">
        <el-table-column label="申请单号" prop="thawCode" />
        <el-table-column label="订单编号" prop="orderCode" />
        <el-table-column label="可解冻总金额" prop="canThawDepositSum" />
        <el-table-column label="申请解冻金额" prop="applyThawDeposit" />
        <el-table-column label="申请时间" prop="createDate" />
        <el-table-column label="状态" prop="thawDepositStatus">
          <template slot-scope="scope">
            <div v-if="scope.row.thawDepositStatus !== '30'">
              {{ scope.row.thawDepositStatus | keyFilter("myOrder", "thawDepositStatus").name }}
            </div>
            <div v-else>
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content" v-html="changeHtml(scope.row.pcAuditRemark)"></div>
                <div class="auditRemark">已驳回
                  <div class="tip-button"><i class="el-icon-info"></i>查看原因</div>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <div class="operate-button"
                 v-if="scope.row.thawDepositStatus === '10'"
                 @click="cancel(scope.row, 'withdraw')">撤回</div>
            <div class="operate-button"
                 v-if="scope.row.thawDepositStatus === '30' || scope.row.thawDepositStatus === '40'"
                 @click="reapply(scope.row)">重新提交</div>
            <div class="operate-button red-button"
                 v-if="scope.row.thawDepositStatus === '30' || scope.row.thawDepositStatus === '40'"
                 @click="cancel(scope.row, 'del')">删除</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <thaw-amount-apply
      v-if="showThawAmountApply"
      :rowData="rowData"
      :isEdit="true"
      @retrieve="retrieve"
      @done="showThawAmountApply = false" />
  </div>
</template>

<script>
import thawAmountApply from './ThawAmountApply.vue'
export default {
  name: 'ThawAmountList',
  components: {
    thawAmountApply
  },
  props: {
    orderCode: { // 订单编号
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableData: [], // 表格数据
      pageSize: 50, // 表格一页数据数量
      currentNo: 1, // 当前页
      loading: false, // 表格加载loading
      thawDepositStatus: '', // 申请状态
      showThawAmountApply: false,
      rowData: {}, // 操作的行数据
    }
  },
  mounted () {
    this.retrieve(1)
  },
  methods: {
    // 获取表格数据
    retrieve (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.loading = true
      this.currentNo = currentNo || this.currentNo || 1
      const url = this.$API.myOrder.myThawDeposit
      const param = {
        currentNo: this.currentNo,
        pageSize: this.pageSize,
        thawDepositStatus: this.thawDepositStatus,
        orderCode: this.orderCode
      }
      this.$http.post(url, param).then(res => {
        this.tableData = res.data.rows
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.loading = false
      })
    },
    // 将字符串中的换行符替换成HTML的换行标签
    changeHtml (str) {
      return str.replace(/\n/g, '<br/>')
    },
    // 删除(type === 'del')和撤回(type === 'withdraw')
    cancel (row, type) {
      const url = type === 'del' ? this.$API.myOrder.deleteThawDeposit : this.$API.myOrder.recallThawDeposit
      const tip = type === 'del' ? '您确定要删除该申请吗？' : '您确定要撤回该申请吗？'
      const param = {
        id: row.id
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.post(url, param).then(() => {
            this.$message.success('操作成功')
            this.retrieve(this.currentNo)
          })
        })
        .catch(() => {})
    },
    // 重新提交
    reapply (row) {
      this.rowData = row
      this.showThawAmountApply = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .tip-button{
    font-size: 12px;
    color: #e6a23c;
  }
</style>
